import { Action } from 'redux';
import { BusinessAreasWithServices, Service } from 'types/Service';

export const SERVICES_RESET_ACTION_TYPE = 'services/reset';
export const SERVICES_ERROR_ACTION_TYPE = 'services/error';

export const SERVICES_FETCH_ACTION_TYPE = 'services/fetch_start';
export const SERVICES_FETCH_SUCCESS_ACTION_TYPE = 'services/fetch_success';
export const BUSINESS_AREAS_FETCH_ACTION_TYPE = 'services/business_areas_fetch_start';
export const BUSINESS_AREAS_FETCH_SUCCESS_ACTION_TYPE = 'services/business_areas_fetch_success';
export const BUSINESS_AREAS_ERROR_ACTION_TYPE = 'services/business_areas_error';

interface ServicesResetAction extends Action<typeof SERVICES_RESET_ACTION_TYPE> {}

interface ServicesFetchAction extends Action<typeof SERVICES_FETCH_ACTION_TYPE> {}
interface ServicesFetchSuccessAction extends Action<typeof SERVICES_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        services: Array<Service>;
    };
}

interface BusinessAreasFetchAction extends Action<typeof BUSINESS_AREAS_FETCH_ACTION_TYPE> {}

interface BusinessAreasFetchSuccessAction
    extends Action<typeof BUSINESS_AREAS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        areas: Array<BusinessAreasWithServices>;
    };
}

interface BusinessAreasErrorAction extends Action<typeof BUSINESS_AREAS_ERROR_ACTION_TYPE> {}

interface ServicesErrorAction extends Action<typeof SERVICES_ERROR_ACTION_TYPE> {}

export type ServicesAction =
    | ServicesResetAction
    | ServicesFetchAction
    | ServicesFetchSuccessAction
    | BusinessAreasFetchAction
    | BusinessAreasFetchSuccessAction
    | BusinessAreasErrorAction
    | ServicesErrorAction;
